import React from 'react';

const transferContext = React.createContext({transfer: {
    
}});

export { transferContext };